var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-dialog",
    {
      attrs: {
        width: "500"
      },
      model: {
        value: _vm.dialog,
        callback: function callback($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "gg-toolbar",
            {
              on: {
                close: _vm.close
              }
            },
            [_vm._v(" Rename MySQL user ")]
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12"
                      }
                    },
                    [
                      _c("p", [
                        _vm._v("Old name: "),
                        _c("strong", [_vm._v(_vm._s(_vm.user.user))])
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("v-text-field", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:".concat(_vm.maxlength),
                    expression: "`required|max:${maxlength}`"
                  }
                ],
                attrs: {
                  outlined: "",
                  label: "New Name",
                  name: "New Name",
                  counter: _vm.maxlength,
                  prefix: _vm.namePrefix,
                  "error-messages": _vm.errors.collect("New Name")
                },
                model: {
                  value: _vm.name,
                  callback: function callback($$v) {
                    _vm.name = $$v
                  },
                  expression: "name"
                }
              })
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "gg-btn",
                {
                  staticClass: "ml-0 mb-0",
                  attrs: {
                    loading: _vm.loading,
                    tile: "",
                    color: "primary"
                  },
                  on: {
                    click: _vm.renameUser
                  }
                },
                [_vm._v("Rename")]
              ),
              _c(
                "gg-btn",
                {
                  staticClass: "mb-0",
                  attrs: {
                    text: "",
                    color: "primary"
                  },
                  on: {
                    click: _vm.close
                  }
                },
                [_vm._v("Cancel")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }